export default {
  title: 'Select Code Batch',
};
